// extracted by mini-css-extract-plugin
module.exports = {"experience":"Experience_experience__1xN__","badge":"Experience_badge__1ZRvM"};